export default {
    conllectionTypeFilter (value) {  // 采集器协议过滤
        if ( value === 1 ) {
            return 'MQTT'
        } else if ( value === 2 ) {
            return "Modbus TCP"
        }  else if ( value === 3 ) {
            return "OCP Server"
        }
        return ""
    },
    mediumValuetypeFilter (value) {
        if(value === '1') {
            return '有符号整数'
        } else if (value === '2') {
            return '无符号整数'
        } else if (value >= '3' && value <= '7') {
            return '小数'
        }
    },
    accuracyFilter (value) {
        if(value === '3') {
            return '精确到0.1'
        } else if (value === '4') {
            return '精确到0.01'
        } else if (value === '5') {
            return '精确到0.001'
        } else if (value === '6') {
            return '精确到0.0001'
        } else if (value === '7') {
            return '精确到0.00001'
        }
    },
    timeFilter (time) {
        let date = new Date(+time)

        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()

        // let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours()
        // let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
        // let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()

        return `${year}-${month}-${day}`
    },
    dayReportFilter (time) {
        let date = new Date(+time * 1000)

        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()

        let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours()
        let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
        let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    moveMediumStyle (item) {  // 元件
        // 比例
        let ratioX,ratioY
        if (item.ratioX) {
            ratioX = item.ratioX
            ratioY = item.ratioY
        } else {
            ratioX = 1
            ratioY = 1
        }

        let flexDirection
        switch (+item.cattribatePlace) {
          case 1:
            flexDirection = 'column-reverse'
            break;
          case 2:
            flexDirection = 'column'
            break;
          case 3:
            flexDirection = 'row-reverse'
            break;
          case 4:
            flexDirection = 'row'
            break;
          default:
            break;
        }
        
        return {
          left: item.cplaceX * ratioX + 'px', 
          top: item.cplaceY * ratioY + 'px',
          'flex-direction': flexDirection
        }
    },
    moveMediumIconStyle (item) {  // 元件图标
      let angle
      switch (item.angle) {
        case '1':
          angle = 0
          break;
        case "2":
          angle = 90
          break;
        case "3":
          angle = 180
          break;
        case "4":
          angle = 270
          break;
        default:
          break;
      }

      let margin
      switch (+item.cattribatePlace) {
        case 1:
          margin = {'margin-top': item.cspacing + 'px'}
          break;
        case 2:
          margin = {'margin-bottom': item.cspacing + 'px'}
          break;
        case 3:
          margin = {'margin-left': item.cspacing + 'px'}
          break;
        case 4:
          margin = {'margin-right': item.cspacing + 'px'}
          break;
        default:
          break;
      }

      return {
        'font-size': item.careaWidth + 'px',
        width: item.careaWidth + 'px',
        height: item.careaLength + 'px',
        transform: `rotate(${angle}deg)`,
        ...margin
      }
    },
    moveMediumAttr (item) { // 元件属性框
      // window.console.log(item)
      let background
      if(item.isShow) {
        background = 'linear-gradient(#0b335d, rgba(109, 125, 203, 0.6))'
      } else {
        background = 'none'
      }
      return {
        overflow: 'auto',
        width: item.cattribateWidth + 'px',
        height: item.cattribateLength + 'px',
        background: background,
      }
    },
    valueFilter (item) {  // 只显示数字
      let notAlarmColor = item.cfontColor || '#7f7'
      let isAlarmColor = '#f00'
      let color = item.isAlarm ? isAlarmColor : notAlarmColor
      return {
        color,
        fontSize: item.cfontSize + 'px'
      }
    },
    symbolFilter (item) {
      let color = item.systemDetailStyleResultList[0].cfontColor || item.cfontColor || '#7f7'
      let fontSize = item.systemDetailStyleResultList[0].cfontSize

      return {
        color,
        fontSize: fontSize + 'px'
      }
    },
    imageFilter (item) {
      let styleObj = item.systemDetailStyleResultList[0]
      
      let width = styleObj.cimageWidth || 30
      let height = styleObj.cimageHeight || 30

      let obj = {
        width: width + 'px',
        height: height + 'px'
      }

      return obj
    }
}